import React from "react";
import { apiGetContactList, apiIsLoggedIn } from "../../api/api";

class ContactListTable extends React.Component {
    headerToKeyMap = {
        "Email": "Email",
        "AcademicTitle": "Academic Title",
        "Title": "Title",
        "FullName": "Full Name",
        "City": "City",
        "Country": "Country",
        "FirstName": "First Name",
        "FamilyName": "Last Name",
    }

    constructor(props) {
        super(props);

        this.state = {
            headers: [],
            contacts: [],
            filteredContacts: [],
            isFiltering: false,
            currentFilter: '',
        };

        this.handleChangeFilter = this.handleChangeFilter.bind(this);
    }

    componentDidMount() {
        apiIsLoggedIn().then(isLoggedIn => {
            if (!isLoggedIn) {
                window.location.href = '/';
            }
        }).catch(error => {
            console.error('Error checking login status:', error);
            window.location.href = '/';
        });

        apiGetContactList().then(response => {
            if (response.ok) {
                response.json().then(data => {
                    this.setState({
                        contacts: this.getSortedContacts("FirstName", data.contacts) || [],
                        headers: data.headers || [],
                        lastClicked: "FirstName",
                        desc: false,
                    });
                }).catch(error => {
                    console.error('Error parsing contact list: ', error);
                });
            } else {
                throw new Error('Failed to fetch contact list');
            }
        });
    }

    handleHeaderClick(header) {
        let lastClicked = this.state.lastClicked;
        let desc = this.state.desc;
        if (lastClicked === header) {
            desc = !desc;
        } else {
            desc = false;
            lastClicked = header;
        }

        const sorted = this.getSortedContacts(header, this.state.contacts, desc);
        // Re-filter contacts to sort them as well
        const filtered = this.filterContacts(this.state.isFiltering, this.state.currentFilter, sorted);
        this.setState({
            contacts: sorted,
            filteredContacts: filtered,
            lastClicked,
            desc,
        });
    }

    getSortedContacts(header, contacts, desc) {
        let sorted = [...contacts].sort((a, b) => {
            if (desc) {
                [a, b] = [b, a]; // Swap a and b if descending
            }
            if (String(a[header]).toLowerCase() < String(b[header]).toLowerCase()) return -1;
            if (String(a[header]).toLowerCase() > String(b[header]).toLowerCase()) return 1;
            return 0;
        });

        if (sorted.length === 0){
            sorted = null;
        }
        
        return sorted
    }

    handleChangeFilter(event) {
        let isFiltering = false;
        if (event.target.value.length > 0) {
            isFiltering = true;
        }

        const currentFilter = event.target.value.toLowerCase();

        const filteredContacts = this.filterContacts(isFiltering, currentFilter, this.state.contacts);
        const sortedFilteredContacts = this.getSortedContacts(this.state.currentFilter, filteredContacts, this.state.desc)

        this.setState({
            filteredContacts: sortedFilteredContacts || [],
            isFiltering,
            currentFilter,
        });
    }

    filterContacts(isFiltering, currentFilter, contacts) {
        let filteredContacts = [];
        if (isFiltering) {
            filteredContacts = contacts.filter(contact =>
                this.state.headers.some(header =>
                    String(contact[header]).toLowerCase().includes(currentFilter)
                )
            );
        }

        return filteredContacts;
    }

    render() {
        const contacts = this.state.isFiltering ? this.state.filteredContacts : this.state.contacts;

        return (
            <div>
                <table border={1} cellPadding={5} cellSpacing={0} className="contact-list-table">
                <caption className="search-bar"><label>Filter: </label><input type="text" onChange={this.handleChangeFilter}></input></caption>
                    <thead>
                        <tr>
                            {this.state.headers.map((header, index) => (
                                <th key={index} onClick={() => this.handleHeaderClick(header)}>
                                    {this.headerToKeyMap[header]} {this.state.lastClicked === header ? (this.state.desc ? '↓' : '↑') : ''}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {contacts.map((contact, index) => (
                            <tr key={index}>
                                {this.state.headers.map((header, headerIndex) => (
                                    <td key={headerIndex}>{contact[header]}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default ContactListTable;
